import React from 'react'
import { SessionStore } from '../../stores'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

@inject('sessionStore')
@observer
class Pendo extends React.Component {
  getPendoScript (options) {
    return `(function(apiKey){
      function hash(n){for(var r=2166136261,t=0;t<n.length;++t)r^=n.charCodeAt(t),r+=(r<<1)+(r<<4)+(r<<7)+(r<<8)+(r<<24);return r>>>0}
        (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
        v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
            o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
            y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
            z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');

            // Call this whenever information about your visitors becomes available
            // Please use Strings, Numbers, or Bools for value types.
            pendo.initialize({
                visitor: {
                    id: hash('${options.visitorId}'), // Required if user is logged in
                    // email:        // Recommended if using Pendo Feedback, or NPS Email
                    // full_name:    // Recommended if using Pendo Feedback
                    'btp_role': '${options.role}',
                    'btp_edition': '${options.edition}',
                    'btp_version': '${options.version}',
                    'btp_resolution': '${window.innerWidth} x ${window.innerHeight}'

                    // You can add any additional visitor level key-values here,
                    // as long as it's not one of the above reserved names.
                },

                account: {
                    id: '${options.accountId}'
                    // name:         // Optional
                    // is_paying:    // Recommended if using Pendo Feedback
                    // monthly_value:// Recommended if using Pendo Feedback
                    // planLevel:    // Optional
                    // planPrice:    // Optional
                    // creationDate: // Optional

                    // You can add any additional account level key-values here,
                    // as long as it's not one of the above reserved names.
                }
            });
    })('${options.appKey}');`
  }

  componentDidMount () {
    window.btp = window.btp || {}
    if (!window.btp.PENDO_INITIALISED && !this.props.sessionStore.sysAdmin) {
      const options = {
        'appKey': this.props.env.PENDO_APP_KEY,
        'visitorId': this.props.sessionStore.user.email,
        'role': this.props.sessionStore.user.roles[0],
        'accountId': this.props.sessionStore.tenant,
        'edition': this.props.sessionStore.user.tenant.Subscription.edition.replace('basic', 'base'),
        'version': this.props.env.VERSION
      }

      const script = document.createElement('script')
      script.textContent = this.getPendoScript(options)

      document.getElementsByTagName('body')[0].appendChild(script)
    }

    window.btp.PENDO_INITIALISED = true
  }

  render () {
    return null
  }
}

Pendo.propTypes = {
  sessionStore: PropTypes.instanceOf(SessionStore),
  env: PropTypes.object
}

export { Pendo }
